











































































































import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import {
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
} from '@/mixins';
import { Links } from '@/mixins/link-mixin';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { AccountPlanTypeResponseModel, SelectOption } from '@/@types/member';
import { getContentArea } from '@/contentful';
import { FDIC_PLAN } from '@/constants';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  confirmBeforeClose: boolean;
  planType: any;
  termsAndConditions: boolean;
  termsAndConditionsRead: boolean;
  custodialAgreementLink: any;
  cashSuppementLink: any;
  cashSupplementFDICLink: any;
  orderArray: string[];
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
  Links,
).extend({
  name: 'UpdatePlanType',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      confirmBeforeClose: true,
      planType: null,
      termsAndConditions: false,
      termsAndConditionsRead: false,
      custodialAgreementLink: null,
      cashSuppementLink: null,
      cashSupplementFDICLink: null,
      orderArray: [
        'PremiumSaver',
        'BasicSaver',
        'ThriftSaver',
        'SelectSaver',
        'FreeSaver',
      ],
    };
  },
  beforeMount() {
    this.showErrorModel.planType = false;
    this.showErrorModel.termsAndConditions = false;
    this.showErrorModel.termsAndConditionsRead = false;
    getContentArea([
      'hsa-custodial-agreement',
      'hsa-custodial-agreement-supplement-fdic-insured-cash-supplement',
      'hsa-custodial-agreement-supplement-paclife-cash-supplement',
    ]).then((data) => {
      const contentAreas = data;
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.custodialAgreementLink = this.parseContentfulLink(contentAreas[0].fields);
        }
        if (contentAreas[1] && contentAreas[1].fields) {
          this.cashSupplementFDICLink = this.parseContentfulLink(contentAreas[1].fields);
        }
        if (contentAreas[2] && contentAreas[2].fields) {
          this.cashSuppementLink = this.parseContentfulLink(contentAreas[2].fields);
        }
      }
    });
  },
  validations: {
    planType: {
      required,
    },
    termsAndConditions: {
      required,
    },
    termsAndConditionsRead: {
      required,
    },
  },
  computed: {
    planTypesContent(): AccountPlanTypeResponseModel[] {
      return this.$store.getters.planTypes(this.params.accountId);
    },
    planTypes(): AccountPlanTypeResponseModel[] {
      return JSON.parse(JSON.stringify(this.planTypesContent));
    },
    sortedPlanTypes(): any {
      // Sort plan types against the order array
      let sortedArray = this.planTypes.sort((a, b) => {
        return (
          this.orderArray.indexOf(a.planDescription) -
          this.orderArray.indexOf(b.planDescription)
        );
      });
      // Remove the current plan type
      sortedArray = sortedArray.filter((item) => {
        return item.planDescription !== this.params.planDescription;
      });
      // Remove plan types where allowChange === false
      sortedArray = sortedArray.filter((item) => {
        return item.allowChange;
      });
      // Remove FreeSaver if hasInvestmentAccount is true
      if (this.params.hasInvestmentAccount) {
        sortedArray = sortedArray.filter((item) => {
          return item.planDescription !== 'FreeSaver';
        });
      }
      return sortedArray;
    },
    planTypeOptions(): SelectOption[] {
      return this.sortedPlanTypes.reduce((map, item) => {
        map.push({ text: item.planDescription, value: item.planType });
        return map;
      }, []);
    },
    cashSupplementIsFDIC(): boolean {
      this.$nextTick(() => {
        this.setLinksClickTrackerFunctionality('termsAndConditionsDiv');
      });
      return this.planType === FDIC_PLAN;
    },

    // VALIDATIONS
    planTypeErrors(): string[] {
      const formField = 'planType';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-plan-type_form-error_plan-type_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    termsAndConditionsErrors(): string[] {
      const formField = 'termsAndConditions';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-plan-type_form-error_terms-and-conditions_required',
            'global_form-error_terms-and-conditions_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    termsAndConditionsReadErrors(): string[] {
      const formField = 'termsAndConditionsRead';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'update-plan-type_form-error_terms-and-conditions_required',
            'global_form-error_terms-and-conditions_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
  },
  methods: {
    tryAgain(): void {
      this.showErrorMessage = false;
      this.confirmBeforeClose = true;
    },
    updatePlanType(): void {
      this.isLoading = true;
      this.$store
        .dispatch('updatePlanInformation', {
          accountId: this.params.accountId,
          planType: this.planType,
        })
        .then(() => {
          this.refreshAccounts();
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshAccounts(): void {
      this.$store
        .dispatch('getAccounts')
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'update-plan-type_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
